import { interval as observableInterval,  Observable } from 'rxjs';
import { debounce } from 'rxjs/operators';
import { Component, Input, Output, EventEmitter, HostListener } from '@angular/core';

@Component({
  selector: 'nns-top-action',
  template: `
    <div class="nns-top-action-button"
      [ngClass]="{'nns-top-action-button-active': showDropdown}"
      (click)="clickAction($event)">
      <span class="nns-top-action-layout" flex layout="row" layout-align="center center">

        <nns-icon [icon]="icon" flex="none"></nns-icon>
        <span class="nns-top-action-text">{{title}}</span>
        <span class="nns-top-action-arrow nns-animated"
          *ngIf="showShareDropdown"></span>
      </span>
    </div>
    <div *ngIf="showShareDropdown && showDropdown" class="nns-top-action-dropdown">
      <div class="nns-top-action-dropdown-inner">
        <nns-social-widget [shareUrl]="shareUrl" [isFolder]="note.type == 'folder'" [share]="share" (onClick)="onSocialClick($event)"></nns-social-widget>
      </div>
    </div>

    <div *ngIf="showLoginDropdown && showDropdown" class="nns-top-action-dropdown">
      <div class="nns-top-action-dropdown-inner">
         <nns-login-dialog></nns-login-dialog>
      </div>
    </div>
  `,
  styles: [
    `
    :host {
      padding:0 8px;
      position:relative;
    }
    .nns-top-action-button {
      cursor:pointer;
      display:block;
      background:none;
      border:none;
      font-size:12px;
      color:#161616;
    }
    .nns-top-action-text {margin:0 0 0 4px;}
    .nns-top-action-arrow {
      display:block;
      content:"";
      height:0;
      border:none;
      border:4px solid transparent;
      border-top:4px solid #3E4849;
      margin:4px 0 0 4px;
    }
    .nns-top-action-button.nns-top-action-button-active .nns-top-action-arrow {
      border-top:none;
      border-bottom:4px solid #3E4849;
    }
    .nns-top-action-button nns-icon{
      min-width: 16px;
      min-height: 16px;
    }
    .nns-top-action-dropdown {
      position:absolute;
      right:0;
      top:100%;
      z-index: 1000;
    }
    .nns-top-action-dropdown-inner {
      padding:12px 0;
    }
  `, `
    :host-context(.nns-theme-night) .nns-top-action-button {
      color:#FFFFFF;
    }
    :host-context(.nns-theme-night) .nns-top-action-arrow {
      border-top-color:#fff;
    }
    :host-context(.nns-theme-night) .nns-top-action-button.nns-top-action-button-active .nns-top-action-arrow {
      border-bottom-color:#fff;
    }
  `
  ]
})
export class TopActionComponent {
  @Input() showShareDropdown;
  @Input() showLoginDropdown;
  @Input() icon;
  @Input() title;
  @Input() shareUrl;
  @Input() note;
  @Input() share;
  @Output() onClick = new EventEmitter();
  dropdownObserver;
  dropdownSubscribe;
  showDropdown = false;

  constructor() {
    const observable = new Observable((observer) => {
      this.dropdownObserver = observer;
    });

    this.dropdownSubscribe = observable.pipe(debounce(() => observableInterval(500)))
      .subscribe((value) => {
        if (value) {
          this.open();
        } else {
          this.close();
        }
      });
  }

  ngOnDestroy() {
    this.dropdownSubscribe.unsubscribe();
  }

  clickAction(event) {
    this.onClick.emit(event);
    if (this.showDropdown) {
      this.close();
    } else {
      this.open();
    }
  }

  close() {
    this.showDropdown = false;
    this.dropdownObserver.next(false);
  }

  open() {
    this.showDropdown = true;
    this.dropdownObserver.next(true);
  }

  onSocialClick(event){
    this.close()
  }

  @HostListener('clickOutside', ['$event'])
  onClickOutside(event) {
    this.close();
    this.dropdownObserver.next(false);
  }
}
